/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum DiscountType {
    None = 'None',
    Fixed = 'Fixed',
    Percentage = 'Percentage'
}

export function DiscountTypeFromJSON(json: any): DiscountType {
    return DiscountTypeFromJSONTyped(json, false);
}

export function DiscountTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscountType {
    return json as DiscountType;
}

export function DiscountTypeToJSON(value?: DiscountType | null): any {
    return value as any;
}

